export default "__VITE_ASSET__tw3PlXXN__"